import React, { useEffect, useState } from 'react';
import { Lead, STAGES } from '../types';
import { todayStr } from '../lib/utils';
interface LeadModalProps {
  isOpen: boolean;
  lead: Lead | null;
  onClose: () => void;
  onSave: (lead: Partial<Lead>) => void;
  onDelete: (id: string) => void;
}
export function LeadModal({
  isOpen,
  lead,
  onClose,
  onSave,
  onDelete
}: LeadModalProps) {
  const [stage, setStage] = useState<Lead['stage']>('new');
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [zone, setZone] = useState('');
  const [type, setType] = useState<Lead['type']>('Tarima flotante');
  const [m2, setM2] = useState('');
  const [value, setValue] = useState('');
  const [src, setSrc] = useState<Lead['src']>('Meta Ads');
  const [next, setNext] = useState('');
  const [notes, setNotes] = useState('');
  useEffect(() => {
    if (lead) {
      setStage(lead.stage);
      setName(lead.name);
      setPhone(lead.phone);
      setZone(lead.zone);
      setType(lead.type);
      setM2(lead.m2);
      setValue(lead.value?.toString() || '');
      setSrc(lead.src);
      setNext(lead.next);
      setNotes(lead.notes);
    } else {
      setStage('new');
      setName('');
      setPhone('');
      setZone('');
      setType('Tarima flotante');
      setM2('');
      setValue('');
      setSrc('Meta Ads');
      setNext('');
      setNotes('');
    }
  }, [lead, isOpen]);
  const handleSave = () => {
    if (!name.trim()) {
      alert('Ponle al menos un nombre al lead.');
      return;
    }
    const data: Partial<Lead> = {
      name: name.trim(),
      phone: phone.trim(),
      zone: zone.trim(),
      type,
      m2: m2.trim(),
      value: +value || 0,
      src,
      next,
      notes: notes.trim(),
      stage
    };
    if (lead) {
      data.id = lead.id;
    } else {
      data.created = todayStr();
    }
    onSave(data);
  };
  const handleDelete = () => {
    if (!lead) return;
    if (!confirm('¿Eliminar este lead?')) return;
    onDelete(lead.id);
  };
  if (!isOpen) return null;
  const phoneClean = String(phone || '').replace(/\D/g, '');
  const phoneWa = phoneClean.startsWith('34') ? phoneClean : '34' + phoneClean;
  return <div className="fixed inset-0 bg-charcoal/55 backdrop-blur-[3px] z-[90] flex items-end md:items-center justify-center" onClick={e => {
    if (e.target === e.currentTarget) onClose();
  }} data-id="element-74">
      <div className="bg-cream w-full max-w-[560px] rounded-t-[22px] md:rounded-[20px] max-h-[92vh] overflow-y-auto p-[22px]" data-id="element-75">
        <h3 className="text-xl font-poppins font-bold mb-1" data-id="element-76">
          {lead ? lead.name || 'Editar lead' : 'Nuevo lead'}
        </h3>
        <p className="text-[13px] text-[#8a8175] mb-[18px]" data-id="element-77">
          {lead ? 'Actualiza la etapa y la fecha del próximo contacto.' : 'Apunta cada persona que escribe.'}
        </p>

        <div className="mb-[14px]" data-id="element-78">
          <label className="block text-[12.5px] font-extrabold mb-[6px] text-charcoal-soft" data-id="element-79">
            Etapa
          </label>
          <div className="grid grid-cols-5 gap-[5px]" data-id="element-80">
            {STAGES.map(st => <button key={st.id} onClick={() => setStage(st.id)} className={`border bg-white rounded-[9px] py-2 px-1 text-[10.5px] font-extrabold font-poppins cursor-pointer leading-tight ${stage === st.id ? 'bg-charcoal text-white border-charcoal' : 'border-line text-[#8a8175]'}`} data-id="element-81">
                {st.short}
              </button>)}
          </div>
        </div>

        <div className="mb-[14px]" data-id="element-82">
          <label className="block text-[12.5px] font-extrabold mb-[6px] text-charcoal-soft" data-id="element-83">
            Nombre del cliente
          </label>
          <input type="text" value={name} onChange={e => setName(e.target.value)} placeholder="Ej. Carmen López" className="w-full border border-line bg-white rounded-[11px] px-[13px] py-3 font-manrope text-[15px] font-medium text-charcoal" data-id="element-84" />
        </div>

        <div className="grid grid-cols-2 gap-[11px]" data-id="element-85">
          <div className="mb-[14px]" data-id="element-86">
            <label className="block text-[12.5px] font-extrabold mb-[6px] text-charcoal-soft" data-id="element-87">
              Teléfono / WhatsApp
            </label>
            <input type="tel" value={phone} onChange={e => setPhone(e.target.value)} placeholder="6XX XXX XXX" className="w-full border border-line bg-white rounded-[11px] px-[13px] py-3 font-manrope text-[15px] font-medium text-charcoal" data-id="element-88" />
          </div>
          <div className="mb-[14px]" data-id="element-89">
            <label className="block text-[12.5px] font-extrabold mb-[6px] text-charcoal-soft" data-id="element-90">
              Zona / barrio
            </label>
            <input type="text" value={zone} onChange={e => setZone(e.target.value)} placeholder="Ej. Gràcia" className="w-full border border-line bg-white rounded-[11px] px-[13px] py-3 font-manrope text-[15px] font-medium text-charcoal" data-id="element-91" />
          </div>
        </div>

        <div className="grid grid-cols-2 gap-[11px]" data-id="element-92">
          <div className="mb-[14px]" data-id="element-93">
            <label className="block text-[12.5px] font-extrabold mb-[6px] text-charcoal-soft" data-id="element-94">
              Tipo de suelo
            </label>
            <select value={type} onChange={e => setType(e.target.value as Lead['type'])} className="w-full border border-line bg-white rounded-[11px] px-[13px] py-3 font-manrope text-[15px] font-medium text-charcoal" data-id="element-95">
              <option data-id="element-96">Tarima flotante</option>
              <option data-id="element-97">Parquet de madera</option>
              <option data-id="element-98">Vinílico / SPC</option>
              <option data-id="element-99">Sin definir</option>
            </select>
          </div>
          <div className="mb-[14px]" data-id="element-100">
            <label className="block text-[12.5px] font-extrabold mb-[6px] text-charcoal-soft" data-id="element-101">
              m² aprox.
            </label>
            <input type="text" inputMode="numeric" value={m2} onChange={e => setM2(e.target.value)} placeholder="Ej. 70" className="w-full border border-line bg-white rounded-[11px] px-[13px] py-3 font-manrope text-[15px] font-medium text-charcoal" data-id="element-102" />
          </div>
        </div>

        <div className="grid grid-cols-2 gap-[11px]" data-id="element-103">
          <div className="mb-[14px]" data-id="element-104">
            <label className="block text-[12.5px] font-extrabold mb-[6px] text-charcoal-soft" data-id="element-105">
              Valor presupuesto (€)
            </label>
            <input type="text" inputMode="numeric" value={value} onChange={e => setValue(e.target.value)} placeholder="Ej. 4200" className="w-full border border-line bg-white rounded-[11px] px-[13px] py-3 font-manrope text-[15px] font-medium text-charcoal" data-id="element-106" />
          </div>
          <div className="mb-[14px]" data-id="element-107">
            <label className="block text-[12.5px] font-extrabold mb-[6px] text-charcoal-soft" data-id="element-108">
              Origen
            </label>
            <select value={src} onChange={e => setSrc(e.target.value as Lead['src'])} className="w-full border border-line bg-white rounded-[11px] px-[13px] py-3 font-manrope text-[15px] font-medium text-charcoal" data-id="element-109">
              <option data-id="element-110">Meta Ads</option>
              <option data-id="element-111">Recomendación</option>
              <option data-id="element-112">Google</option>
              <option data-id="element-113">Otro</option>
            </select>
          </div>
        </div>

        <div className="mb-[14px]" data-id="element-114">
          <label className="block text-[12.5px] font-extrabold mb-[6px] text-charcoal-soft" data-id="element-115">
            Próximo seguimiento
          </label>
          <input type="date" value={next} onChange={e => setNext(e.target.value)} className="w-full border border-line bg-white rounded-[11px] px-[13px] py-3 font-manrope text-[15px] font-medium text-charcoal" data-id="element-116" />
        </div>

        <div className="mb-[14px]" data-id="element-117">
          <label className="block text-[12.5px] font-extrabold mb-[6px] text-charcoal-soft" data-id="element-118">
            Notas
          </label>
          <textarea value={notes} onChange={e => setNotes(e.target.value)} placeholder="Ej. Quiere para fin de mes. Comparó con otra empresa." className="w-full border border-line bg-white rounded-[11px] px-[13px] py-3 font-manrope text-[15px] font-medium text-charcoal min-h-[64px] resize-y" data-id="element-119" />
        </div>

        {phoneClean && <div className="flex gap-[7px] flex-wrap mb-2" data-id="element-120">
            <a href={`https://wa.me/${phoneWa}`} target="_blank" rel="noopener noreferrer" className="flex-1 text-center bg-wa text-white no-underline font-extrabold text-[13px] py-[11px] rounded-[11px] flex items-center justify-center gap-[6px] hover:bg-wa-dark transition-colors" data-id="element-121">
              WhatsApp
            </a>
            <a href={`tel:${phoneClean}`} className="flex-1 text-center bg-charcoal text-white no-underline font-extrabold text-[13px] py-[11px] rounded-[11px] flex items-center justify-center gap-[6px] hover:bg-charcoal-soft transition-colors" data-id="element-122">
              Llamar
            </a>
          </div>}

        <div className="flex gap-[10px] mt-2" data-id="element-123">
          <button onClick={onClose} className="flex-1 bg-white text-charcoal border border-line font-manrope font-extrabold rounded-[11px] px-4 py-[11px] text-[14.5px] hover:bg-gray-50 active:scale-[0.97] transition-all flex items-center justify-center" data-id="element-124">
            Cancelar
          </button>
          <button onClick={handleSave} className="flex-1 bg-wood text-white font-manrope font-extrabold rounded-[11px] px-4 py-[11px] text-[14.5px] hover:brightness-110 active:scale-[0.97] transition-all flex items-center justify-center" data-id="element-125">
            Guardar
          </button>
        </div>

        {lead && <div className="mt-[10px]" data-id="element-126">
            <button onClick={handleDelete} className="w-full bg-transparent text-red border border-[#f0c9c7] font-manrope font-extrabold rounded-[11px] px-4 py-[11px] text-[14.5px] hover:bg-red/5 active:scale-[0.97] transition-all" data-id="element-127">
              Eliminar lead
            </button>
          </div>}
      </div>
    </div>;
}